<!-- Modals -->
<ui-dialog
    [open]="currentlyOpenDialog === 'ACKNOWLEDGE'"
    [form]="acknowledgeForm.form"
    header="document.acknowledgeDocument"
    primaryButtonLabel="document.acknowledge"
    (primaryButtonPressed)="onAcknowledge()"
    size="small"
    (closing)="closeDialog()"
    secondaryButtonLabel="cancel"
    (secondaryButtonPressed)="closeDialog()"
    [isCloseable]="false"
>
    <app-document-acknowledge-form #acknowledgeForm></app-document-acknowledge-form>
</ui-dialog>

<ui-confirmation-dialog
    primaryButtonLabel="document.delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    header="document.deleteDocumentFromEmployee"
    #confirmDeleteDialog
>
    <p *ngIf="isIncompleteSignatureRequest">{{ 'document.isIncompleteSignatureRequest' | translate }}</p>
    {{
        'document.deleteDocumentFromEmployeeNotice'
            | translate: { documentName: employeeDocument?.name, employeeName: employeeDocument?.employee?.firstName }
    }}
</ui-confirmation-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'DETAILS'"
    size="small"
    header="document.documentDetails"
    (closing)="closeDialog()"
>
    <app-document-details [document]="employeeDocument"></app-document-details>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'EDIT'"
    size="small"
    primaryButtonLabel="save"
    (primaryButtonPressed)="onSave(editForm)"
    secondaryButtonLabel="cancel"
    (secondaryButtonPressed)="closeDialog()"
    (closing)="closeDialog()"
    [form]="editForm.form"
    header="document.editDocument"
>
    <app-employee-document-form
        #editForm
        [isSelfUpload]="viewingSelf"
        [employeeDocument]="employeeDocument"
        [roles]="roles"
    >
    </app-employee-document-form>
</ui-dialog>

<ng-template #status
    ><span *ngIf="employeeDocument.isComplete()">
        {{
            'document.actionedOn'
                | translate
                    : { action: employeeDocument.getVerb() | translate, date: employeeDocument.completedAt() | appDate }
        }}</span
    >
    <span *ngIf="!employeeDocument.isComplete()">
        {{ 'document.notActionedYet' | translate: { action: employeeDocument.getVerb() | translate } }}
    </span>
</ng-template>

<!-- Body -->
<div class="page-container no-scroll">
    <app-header
        [title]="employeeDocument?.name"
        [back]="true"
        [backRoute]="employeeDocumentBackRoute()"
        [contextMenu]="true"
    >
        <div class="buttons">
            <ng-container *ngIf="employeeDocument.isActionable()">
                <ui-button
                    type="primary"
                    *ngIf="userCanAcknowledge && !employeeDocument.isComplete(); else status"
                    (click)="currentlyOpenDialog = 'ACKNOWLEDGE'"
                    >{{ 'document.acknowledge' | translate }}</ui-button
                >
            </ng-container>
        </div>

        <app-context-item (click)="onDownload()" label="{{ 'document.download' | translate }}"></app-context-item>
        <app-context-item
            *ngIf="!employeeDocument.isActionable()"
            (click)="onDetails()"
            label="{{ 'document.details' | translate }}"
        ></app-context-item>
        <app-context-item
            *ngIf="canEdit && !employeeDocument.isActionable()"
            (click)="currentlyOpenDialog = 'EDIT'"
            label="{{ 'document.edit' | translate }}"
        ></app-context-item>
        <app-context-item
            *ngIf="canDelete"
            (click)="onDelete()"
            label="{{ 'document.delete' | translate }}"
        ></app-context-item>
    </app-header>

    <div class="file-wrapper">
        <app-file-viewer [file]="employeeDocument.file"></app-file-viewer>
    </div>
</div>
